import { useEffect, useRef } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = new URLSearchParams(
      window.location.hash.replace(/^#/, "")
    ).get("session_id");

    (async () => {
      try {
        const { data } = await api.post(
          "/auth/session",
          { session_id: sessionId },
          { headers: { "X-Session-ID": sessionId } }
        );
        setUser(data);
        window.history.replaceState({}, document.title, "/dashboard");
        window.location.replace("/dashboard");
      } catch {
        window.location.replace("/");
      }
    })();
  }, [setUser]);

  return (
    <div className="min-h-screen bg-sand flex items-center px-8">
      <p className="font-heading text-2xl text-deep-olive">Preparing your kitchen…</p>
    </div>
  );
};
